import React from "react";
import classNames from "classnames";
import { useOCRContext } from "@context/OCRContext";
import { Info } from "@Icons";

const IdCard = () => {
  const { result } = useOCRContext();
  const ssaResult = result.ocr_result.id_truth === "REAL";

  const jumin = result.ocr_result.jumin
    ? `${result.ocr_result.jumin?.slice(0, 6)} - ${result.ocr_result.jumin?.slice(6)}`
    : "";
  const issuedDate = result.ocr_result.issued_date?.replaceAll(".", ". ") || "";

  return (
    <div className="content">
      <ul>
        <li>
          <span className="label">신분증 종류</span>
          <span className="value">주민등록증</span>
        </li>
        <li>
          <span className="label">사본여부</span>
          <span className={classNames("value", ssaResult ? "ssa-true" : "ssa-false")}>
            {ssaResult ? "TRUE" : "FALSE"}
          </span>
        </li>
        <li>
          <span className="label">이름</span>
          <span className="value">{result.ocr_result.name}</span>
        </li>
        <li>
          <span className="label">주민등록번호</span>
          <span className="value">{jumin}</span>
        </li>
        <li>
          <span className="label">발급일자</span>
          <span className="value">{issuedDate}</span>
        </li>
        <li>
          <span className="label">발급처</span>
          <span className="value">{result.ocr_result.region}</span>
        </li>
      </ul>
      <div className="info">
        <Info st={{ fontSize: "16px" }} />
        {ssaResult ? (
          <span>
            정보가 맞지 않다면 <b>이전(재촬영)</b>을 눌러 주시고, 정보가 맞으면 <b>다음</b>으로 진행해 주세요.
          </span>
        ) : (
          <span>
            사본으로 확인되었습니다. <b>재촬영</b>해 주세요.
          </span>
        )}
      </div>
    </div>
  );
};
export default IdCard;
